export function getChatWidgetCode(topLevelDomain, companyHash, jobHash = null) {
  topLevelDomain = topLevelDomain || 'com';

  let jobHashLine = '';

  if (jobHash) {
    jobHashLine = `\t\tjobHash: '${jobHash}',\n`;
  }

  return (
    '<link rel="stylesheet" href="https://app.hrblade.' +
    topLevelDomain +
    '/w/style.css">\n' +
    '<script src="https://app.hrblade.' +
    topLevelDomain +
    '/w/chat-widget.umd.js"></script>\n' +
    '<script>\n' +
    '\twindow.initChatWidget({\n' +
    `\t\tcompanyHash: '${companyHash}',\n` +
    jobHashLine +
    `\t\tcolor: '', // Optional\n` +
    `\t\tbuttonText: '', // Optional\n` +
    '\t})\n' +
    '</script>'
  );
}

export function copyText(text) {
  if (!navigator.clipboard) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  } else {
    navigator.clipboard.writeText(text).catch((err) => {
      console.error(err);
    });
  }
}

export function getTLD(hostname) {
  const parts = hostname.split('.');
  return parts.length > 1 ? parts[parts.length - 1] : null;
}

export function getTopLevelDomain(url) {
  try {
    const hostname = new URL(url).hostname;
    const parts = hostname.split('.');
    return parts[parts.length - 1];
  } catch (e) {
    console.error(e.message);
  }
}

export async function downloadBlob(response) {
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;

  const contentDisposition = response.headers.get('content-disposition');
  let filename = `${Date.now()}.csv`;

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);

    if (match) {
      filename = match[1];
    }
  }

  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
